import Feature from "./Feature";

const unusedString = "***** This is presently not used! *****";
const FeatureDescription = {
	[Feature.MARITIME.BOUNDARIES.VIEW]: "View Maritime Boundaries",
	[Feature.MARITIME.NAUTICAL_CHARTS.VIEW]: "View Nautical Charts",
	[Feature.MARITIME.ENHANCED_VESSEL_DATA.VIEW]: "View Enhanced Vessel Data tab",
	[Feature.MARITIME.HOTSPOTS.STS.VIEW]: "View Ship-to-ship Hotspots",
	[Feature.MARITIME.UKHO.FEATURES.VIEW]: "View UKHO Maritime Features",
	[Feature.MARITIME.PORTS.STATS.VIEW]: "View Ports Stats",
	[Feature.MARITIME.MISS.VIEW]: "View Maritime Incidents",
	[Feature.MARITIME.SHIPPING_LANE_ROUTING.VIEW]: "View Shipping Lanes - Routing",
	[Feature.MARITIME.VESSEL_COMMENTS.VIEW]: "View Vessel Discussion & Comments",
	[Feature.MARITIME.VESSEL_COMMENTS.EDIT]: unusedString,
	[Feature.MARITIME.MARMANS.VIEW]: "View MARMANs",
	[Feature.MARITIME.RISKINTELLIGENCE.INCIDENTS.VIEW]: "View RiskIntelligence Incidents",
	[Feature.MARITIME.RISKINTELLIGENCE.PORTS.VIEW]: "View RiskIntelligence Ports",
	[Feature.MARITIME.NATIONALGRID.UNDERSEA_CABLES.VIEW]: "View BritNed Cable Risks",
	[Feature.MARITIME.OFFSHORE_INFRASTRUCTURE.VIEW]: "View Offshore Infrastructure",

	[Feature.ALERTS.VIEW]: "View Alerts",
	[Feature.ALERTS.FILTER]: "Filter ALerts",
	[Feature.ALERTS.DOWNLOAD]: "Download Alerts as CSV/JSON",

	[Feature.VESSEL_HISTORY.VIEW]: "View Vessel History query",
	[Feature.VESSEL_HISTORY.SEARCH_BY_MMSI]: "Search Vessel History by MMSI",
	[Feature.VESSEL_HISTORY.INVESTIGATE]: "Investigate Data Gaps and Merged Points in Vessel History data.",
	[Feature.VESSEL_HISTORY.RESTRICTED_INPUTS]: "Restrict Vessel History query input to select IMOs/MMSIs",

	[Feature.VESSELS_NEARBY.VIEW]: "View Nearby Vessels query",

	[Feature.ENVIRONMENT.VIEW]: "View Environment Data",
	[Feature.ENVIRONMENT.HISTORY.TWO_YEARS]: "Restrict Environment Data to 2 years",

	[Feature.HURRICANES.VIEW]: "View Tropical Storms",
	[Feature.VOLCANOES.VIEW]: "View Volcanoes",
	[Feature.EARTHQUAKES.VIEW]: "View Earthquakes",
	[Feature.FLOODS.VIEW]: "View Floods",

	[Feature.PORT_ASSESSMENTS.VIEW]: "View Port Assessments",
	[Feature.SATELLITE_IMAGERY.VIEW]: "Toggle Satellite Imagery view",
	[Feature.TIME_SLIDER.VIEW]: "Ability to scrobble through Vessel historic paths and historic Environment data.",
	[Feature.GRAPHS.VIEW]: "View Vessel Graphs (e.g. speed/time, course/time)",
	[Feature.SANCTIONS.VIEW]: "View Sanctions (EU, UN, US, and OFAC)",
	[Feature.SHIPPING_LANES.VIEW]: "View Shipping Lanes",
	[Feature.TIMEZONES.VIEW]: "View Timezones",

	[Feature.IMAGE_ASSETS.VIEW]: "View Image Collections",
	[Feature.IMAGE_ASSETS.EDIT]: "Ability to create and upload Images/Image Collections",

	[Feature.ANNOTATIONS.VIEW]: "View and edit Annotations",
	[Feature.NOTEPAD.VIEW]: "View Notepad",
	[Feature.NOTEPAD.EDIT]: unusedString,
	[Feature.MEASURE.VIEW]: "Ability to view and motify Route Plot & Measure tools",
	[Feature.SAR_DVD.VIEW]: "Ability to view SAR-derived Dark Vessel Detections",
	[Feature.SATELLITE_RFD.VIEW]: "Ability to view Satellite-derived RF Detections",
	[Feature.AVIATION.NOTAMS.VIEW]: "View Aviation NOTAMS",
	[Feature.AVIATION.VIEW]: "View Aviation Data",
	[Feature.COMPANY.VIEW]: unusedString,
	[Feature.COMPANY.EDIT]: unusedString,

	[Feature.ADMIN.VIEW]: "Ability to view the Admin CMS overlay. ",
	[Feature.ADMIN.EDIT]: "Ability to edit ALL DATA in the Admin CMS. Checking this overrides toggles for other CMS options.",
	[Feature.ADMIN.USERS.VIEW]: "Ability to view the User tab in the Admin CMS",
	[Feature.ADMIN.USERS.EDIT]: "Ability to add/edit/delete Users in the Admin CMS",
	[Feature.ADMIN.COMPANIES.VIEW]: "Ability to view the Companies tab in the Admin CMS",
	[Feature.ADMIN.COMPANIES.EDIT]: "Ability to add/edit/delete Companies in the Admin CMS",
	[Feature.ADMIN.TIERS.VIEW]: "Ability to view the Tiers tab in the Admin CMS",
	[Feature.ADMIN.TIERS.EDIT]: "Ability to add/edit/delete Tiers in the Admin CMS",
	[Feature.ADMIN.ROIS.VIEW]: "Ability to view the ROIs tab in the Admin CMS",
	[Feature.ADMIN.ROIS.EDIT]: "Ability to add/edit/delete ROIs in the Admin CMS",
	[Feature.ADMIN.IMAGES.VIEW]: "Ability to view the Images tab in the Admin CMS",
	[Feature.ADMIN.IMAGES.EDIT]: "Ability to add/edit/delete Images and Image Collections in the Admin CMS",
	[Feature.ADMIN.COMMENTS.VIEW]: "Ability to view the Vessel Comments tab in the Admin CMS",
	[Feature.ADMIN.COMMENTS.EDIT]: "Ability to add/edit/delete Vessel Comments & Threads in the Admin CMS"

};
export default FeatureDescription;
